// Action Types
export const PENDING_CALL_RECIEVED = 'PENDING_CALL_RECIEVED'
export const JOIN_VIDEO_RESOLVED = 'JOIN_VIDEO_RESOLVED'
export const VIDEO_CALL_INITED = 'VIDEO_CALL_INITED'
export const PATIENT_LEFT_ROOM = 'PATIENT_LEFT_ROOM'
export const ROOM_COMPLETED = 'ROOM_COMPLETED'
export const CALL_ENDED_BY_PATIENT = 'CALL_ENDED_BY_PATIENT'
export const RATE_US_POPUP_TRIGGED = 'RATE_US_POPUP_TRIGGED'
export const VIDEO_QUALITY_COLLECTED = 'VIDEO_QUALITY_COLLECTED'
export const REPORT_LOW_QUALITY_VIDEO = 'REPORT_LOW_QUALITY_VIDEO'
export const VOIP_REGISTER_REQUESTED = 'VOIP_REGISTER_REQUESTED'
export const VIDEO_CALL_DIALOG_VISIBLE = 'VIDEO_CALL_DIALOG_VISIBLE'
export const GET_OTHER_PARTICIPANT = 'GET_OTHER_PARTICIPANT'
export const VIDEO_CALL_STATUS_CHANGED = 'VIDEO_CALL_STATUS_CHANGED'
